import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AuditBenchSummaryInputDTO } from 'app/model/audit-bench-summary-input-dto';
import { CommonDTO } from 'app/model/common-dto';
import { UrlConfigService } from 'app/service/url-config.service';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NonNcscopeService {
  // url = environment.SERVER_URL;
  url: string;

  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  getList(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {
    return this.http.post(`${this.url}common/get-non-nc-scope-rating`, auditBenchSummaryInputDTO);
  }
}
